import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AuthService } from '../../services/auth.service'

// Sidebar-hiding is not access control, so this guard redirects an in-SPA
// navigation to a revoked/unauthorized System Monitor away from the page.
// `currentUser` is a signal kept in sync by DashboardComponent's whoAmI fetch;
// on a cold load (hard refresh / bookmark) it is still null when guards run, so
// this defers (returns true) exactly like the kycRequiredGuard / orgKycGuard
// pattern in app.routes.ts. In that cold-load case the backend gate (every
// System Monitor endpoint 403s without the out-of-band grant) remains the real
// boundary; this guard is the in-session UX layer on top of it.
export const canAccessSystemMonitorGuard: CanActivateFn = () => {
  const authService = inject(AuthService)
  const router = inject(Router)
  const user = authService.currentUser()
  if (!user) return true
  if (user.backoffice?.canAccessSystemMonitor) return true
  return router.createUrlTree(['/trading-hub/dashboard/bo-overview'])
}
